import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useEffect, useState } from 'react';
import { BackendFolder } from '@/types/backend';
import { Folder } from '@/types/folder';
import FolderTreeView from '@/components/navigation/folder/FolderTreeView';
import SingleInputDialog from '@/components/common/dialogs/SingleInputDialog';

type CreateFolderDialogProps = {
  folders: BackendFolder[] | undefined;
  open: boolean;
  onSelect: (folderName: string, parentFolderId: number | undefined) => void;
  onClose: () => void;
};

const CreateFolderDialog: FC<CreateFolderDialogProps> = (props) => {
  const [selectedFolderId, setSelectedFolderId] = useState<number>();
  const [openSubDialog, setOpenSubDialog] = useState(false);

  const handleDoubleClick = (folder: Folder) => {
    setSelectedFolderId(folder.folderId);
    setOpenSubDialog(true);
  };

  const handleCreateNewFolder = (folderName: string) => {
    setOpenSubDialog(false);
    props.onSelect(folderName, selectedFolderId);
  };

  useEffect(() => {
    if (props.open && !props.folders?.length) {
      setOpenSubDialog(true);
    }
  }, [props.open]);

  return (
    <>
      {props.folders && props.folders.length > 0 && (
        <Dialog open={props.open} onClose={props.onClose} maxWidth='sm' fullWidth>
          <DialogTitle>Select folder under which to create folder</DialogTitle>
          <DialogContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <FolderTreeView
              folders={props.folders}
              foldersOnly
              onFolderClick={(folder) => setSelectedFolderId(folder.folderId)}
              onFolderDoubleClick={(folder) => handleDoubleClick(folder)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={props.onClose} color='primary'>
              Cancel
            </Button>
            <Button onClick={() => setOpenSubDialog(true)} color='primary'>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <SingleInputDialog
        title='Folder Name'
        label='Folder Name'
        confirmLabel='Create'
        open={openSubDialog}
        onClose={() => setOpenSubDialog(false)}
        onConfirm={(folderName) => handleCreateNewFolder(folderName)}
      />
    </>
  );
};

export default CreateFolderDialog;
